import { useNavigate } from "@tanstack/react-router"
import { IconArrowsExpandDiagonal4Outline18 as Expand } from "nucleo-ui-outline-18"

import type { CopilotScope } from "@productlane/lib/src/ai"
import { IconButton, Tooltip } from "@productlane/ui"

import { useIsAgentPageAvailable } from "@/lib/hooks/use-is-agent-page-available"
import { expandedChatPath } from "../../../../agent/agent-route"

// Opens the same chat full width on the Agent page. The chat store keeps the
// scope's messages, so the conversation carries over without a reload.
export const ExpandToAgentButton = ({
	scope,
	onExpand,
}: {
	scope: CopilotScope
	// Closes the panel first, so the chat never runs in two places at once.
	onExpand: () => void
}) => {
	const navigate = useNavigate()
	const available = useIsAgentPageAvailable()
	if (available !== true) return null
	return (
		<Tooltip label="Open in Agent" side="bottom">
			<IconButton
				Icon={Expand}
				iconStrokeWidth={1.5}
				variant="ghost"
				size="default"
				aria-label="Open in Agent"
				data-testid="copilot-expand"
				onClick={() => {
					onExpand()
					void navigate({ href: expandedChatPath(scope) })
				}}
			/>
		</Tooltip>
	)
}
